export class UpdateOrganizationUserResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "user",
            "baseName": "user",
            "type": "OrganizationUser",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateOrganizationUserResponse.attributeTypeMap;
    }
    constructor() {
    }
}
